import { Injectable } from '@angular/core';
import { MembersAthletesFiltersServiceService } from 'src/app/members/details-page/members-athletes/services/members-athletes-filters-service.service';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { CountryCombo, HistoricalComboAthlete } from '../../common-page-components/stores/filters-store/filters-store';
import { Observable } from 'rxjs/Observable';
import { combineLatest, of } from 'rxjs';
import { map, mergeMap, filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class FilterAthletesService extends MembersAthletesFiltersServiceService {
  countryCombo = new CountryCombo('Country:', 'country-combo', this.http_self,  [{ item: { CShort: 'All' }, position: 0 }], 'country', true, true);
  activeCombo = new HistoricalComboAthlete('Current:', 'currentcombo', undefined,
  [{ item: { Name: 'All' }, position: 0 }, { item: { Name: 'Current' }, position: 1 }, { item: { Name: 'Historical' }, position: 2 }]);

  filtersType = [
    this.textFilter.filterInfo,
    this.countryCombo.filterInfo,
    this.categoryCombo.filterInfo,
    this.activeCombo.filterInfo
  ]
  constructor(private http_self:HttpClient, private router_self:Router) {
    super(http_self, router_self);
    this.countryCombo.filterInfo.options.selectMultiple = true;
    this.countryCombo.filterInfo.options.initial_state = true;
    this.countryCombo.filterInfo.options.options_selected_subject.next([]);
   }

   getDataStreamWithFilters(){
      // tslint:disable-next-line:max-line-length
      return super.getDataStreamWithFilters().pipe(mergeMap(([order, text, category, active, country])=>{
        return combineLatest(
          [this.orderValue, this.textFilter.data(),
          this.categoryCombo.comboData,
          this.activeCombo.comboData,
          this.countryCombo.comboData.pipe(filter(a => a!= null),map(a=>a.NOC))
        ]);
      }))
   }
}
